import { Component } from '@angular/core';

@Component({
  selector: 'coupon-routing',
  template: `
    <article class="component">
      <h1>Gutscheine</h1>
      <router-outlet></router-outlet>
    </article>
  `,
  styles: [ 'section table { width: 100%; }' ]
})
export class CouponEntryView {}
